import { FC, HTMLAttributes, useMemo } from "react";
import styled from "styled-components";

const MoreButton: FC<HTMLAttributes<HTMLButtonElement> & { opened: boolean }> = ({ opened, ...props }) => {
  const imageFile = useMemo(() => (opened ? "news_btn_up.png" : "news_btn_down.png"), [opened]);
  return (
    <Root {...props}>
      <Image src={`/image/lp/gonzo/news/btn/${imageFile}`} alt="more" />
    </Root>
  );
};
export default MoreButton;

const Root = styled.button`
  background-color: #ff0004;
  @media screen and (max-width: 960px) {
    width: 100px;
    padding: 8px 15px;
  }
  @media screen and (min-width: 961px) {
    width: 200px;
    height: 50px;
    padding: 16px 30px;
  }
`;

const Image = styled.img`
  vertical-align: baseline;
  @media screen and (max-width: 960px) {
    width: 70px;
  }
  @media screen and (min-width: 961px) {
    width: 140px;
    height: 18px;
  }
`;
